module.exports = __webpack_public_path__ + "img/145-Teck de Java - Sheffield Oak Light.jpg";